function About() {
  return (
    <section id="about" className="relative w-full bg-[#080808] px-8 py-28 md:px-16 md:py-40 lg:px-28">
      <p className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]">02</p>
      <h2 className="font-display mt-6 text-center text-2xl text-[#f7f1e6] md:text-6xl">
        關於〈Free Man〉
      </h2>
      <div className="mt-16 flex w-full flex-col items-center gap-12 md:mt-24 md:gap-10">
        <p className="font-serif-tc mx-auto max-w-2xl text-center text-sm leading-relaxed text-stone-200 sm:text-base">
          〈Free Man〉唱出掙脫束縛、追尋自由的渴望，
          <br className="md:hidden" />
          在音樂與氣味之間，留下屬於野東西的自由印記。
        </p>
        <div className="font-sans-ui mx-auto max-w-xl space-y-8 text-center text-[13px] leading-7 tracking-wide text-stone-400 md:space-y-10 md:text-sm md:leading-8">
          <p>
            這不是一瓶香水
            <br />
            這是野東西
            <br />
            寫給舞台之外的一首歌
          </p>
          <p>
            〈Free Man〉談的是不被馴養的心。
            <br />
            想走自己的路，想把聲音交給風，
            <br />
            也想把自由，變成能被記住的感覺。
          </p>
          <p>
            音樂留下聲音
            <br />
            氣味留下記憶
          </p>
          <p>
            當旋律結束，香氣才剛開始。
            <br />
            從耳朵聽見的渴望，
            <br />
            走到皮膚上停留的溫度。
          </p>
          <p>
            下一個舞台
            <br />
            我們不只用耳朵聽
          </p>
        </div>
      </div>
    </section>
  )
}

export default About
